// Shared client-side form validation.
// Rules are intentionally kept in sync with the backend validators in
// backend/routes/forms.py so that anything the UI accepts the API also accepts.

const PHONE_ALLOWED = /^[+0-9\s().-]+$/;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Name: 2-100 chars after trimming and must contain at least one letter
// (rejects values like "12345" or "!!!!").
export function validateName(value) {
  const v = (value || '').trim();
  if (v.length < 2 || v.length > 100) return 'Please enter your full name.';
  if (!/[a-zA-ZÀ-ɏ]/.test(v)) return 'Name must contain letters.';
  return '';
}

export function validateEmail(value) {
  const v = (value || '').trim();
  if (!v) return 'Please enter your email address.';
  if (!EMAIL_RE.test(v)) return 'Please enter a valid email address.';
  return '';
}

// Phone: if provided, allow only phone characters and require 7-15 digits.
// When required is false, an empty value is accepted.
export function validatePhone(value, { required = false } = {}) {
  const v = (value || '').trim();
  if (!v) return required ? 'Please enter your phone number.' : '';
  if (!PHONE_ALLOWED.test(v)) return 'Phone number contains invalid characters.';
  const digits = (v.match(/\d/g) || []).length;
  if (digits < 7 || digits > 15) return 'Please enter a valid phone number.';
  return '';
}

// Turn a backend error (Axios error or fetch Response body) into a readable
// string. FastAPI validation errors come back as { detail: [ { msg, loc } ] },
// which must never be rendered directly as a React child.
export function parseApiError(detail, fallback = 'Something went wrong. Please try again.') {
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const first = detail[0];
    if (first && typeof first.msg === 'string') {
      return first.msg.replace(/^Value error,\s*/, '');
    }
  }
  return fallback;
}
